import {DrawingMode} from './drawing-mode';
import {SmartWhiteboard} from '../smart-whiteboard';

export class DrawingModeHandler {

  public static setDrawingMode(swb: SmartWhiteboard, dm: DrawingMode) {
    switch (dm) {
      case DrawingMode.PENCIL:
        swb.setPencilMode();
        break;
      case DrawingMode.LINE:
        swb.setLineMode();
        break;
      case DrawingMode.RECTANGLE:
        swb.setRectangleMode();
        break;
      case DrawingMode.ELLIPSE:
        swb.setEllipseMode();
        break;
      case DrawingMode.UML:
        swb.setUMLMode();
        break;
      case DrawingMode.UML_DIAMOND:
        swb.setUMLDiamondMode();
        break;
      case DrawingMode.SHAPE_PHONE:
        swb.setPhoneShapeMode();
        break;
      case DrawingMode.SHAPE_TABLET:
        swb.setTabletShapeMode();
        break;
      case DrawingMode.SHAPE_DESKTOP:
        swb.setDesktopShapeMode();
        break;
      case DrawingMode.TEXT:
        swb.setTextMode();
        break;
      case DrawingMode.SELECTION:
        swb.setSelectionMode();
        break;
    }
  }

}
